import { Stack } from 'expo-router';

export default function EventsTabLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
